module.exports = __webpack_public_path__ + "img/org-members.09276f7.png";